
















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import EnvelopIcon from '@/components/Helper/Icon/Svg/EnvelopIcon.vue';
import PadlockIcon from '@/components/Helper/Icon/Svg/PadlockIcon.vue';

@Component<CInputLabel>({
  components: { PadlockIcon, EnvelopIcon },
})
export default class CInputLabel extends Vue {
  @Prop({ type: String })
  icon: string;

  get iconType() {
    if (this.icon.startsWith('mdi')) {
      return 'mdi';
    }
    if (this.icon.endsWith('icon')) {
      return 'svg';
    }
    return 'image';
  }
}
